import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AlignmentEditor from 'common/components/AlignmentEditor';

import { setFormSubmitButtonPosition } from 'common/entities/form/styleConfiguration/actions';
import { DEFAULT_BUTTON_POSITION } from 'common/entities/form/styleConfiguration/defaultValues';
import { LEFT, CENTER, RIGHT } from 'common/entities/form/styleConfiguration/constants';

import { getButtonPosition } from 'common/entities/form/styleConfiguration/selectors';
import { getFormId } from '../../../../selectors';

import { BUTTON_QA } from '../../../../utils/qaIdConstants';
import { BUTTON_ALIGNMENT_LABEL } from '../../../../constants/formStyleLabels';

const ButtonBackgroundPanel = ({ formId, buttonPosition, ...props }) => (
    <AlignmentEditor
        label={BUTTON_ALIGNMENT_LABEL}
        position={buttonPosition}
        onChangePosition={(position) => props.setFormSubmitButtonPosition(formId, position)}
        qaId={`${BUTTON_QA}--alignment`}
        allowFullWidth
    />
);

ButtonBackgroundPanel.propTypes = {
    formId: PropTypes.string.isRequired,
    buttonPosition: PropTypes.oneOf([LEFT, CENTER, RIGHT]),
    setFormSubmitButtonPosition: PropTypes.func.isRequired,
};

ButtonBackgroundPanel.defaultProps = {
    buttonPosition: DEFAULT_BUTTON_POSITION,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const buttonPosition = getButtonPosition(state, formId);

    return {
        formId,
        buttonPosition,
    };
};

const mapDispatchToProps = {
    setFormSubmitButtonPosition,
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonBackgroundPanel);
